/**
 * Transparenzregeln. Nicht optional und nicht ueberschreibbar:
 * Teilnehmer muessen erkennen koennen, dass hier eine KI im Meeting sitzt.
 */
/** Muss im Anzeigenamen enthalten sein. */
export const AI_MARKER = '(AI-AVA)';
/**
 * Erkennt eine bereits vorhandene Kennzeichnung, damit sie nicht doppelt landet.
 *
 * Die alte Schreibweise (KI-Avatar) zaehlt weiterhin als Kennzeichnung. Sonst
 * bekaeme ein Name, in den jemand die alte Form selbst tippt, beide angehaengt
 * ("Lea (KI-Avatar) (AI-AVA)"), und in der Historie stuenden Namen, die als
 * ungekennzeichnet gelten, obwohl sie es nicht sind.
 */
const AI_MARKER_PATTERN = /\(\s*(?:AI[- ]?AVA|KI[- ]?Avatar)\s*\)/i;
export function hasAiMarker(displayName) {
    return AI_MARKER_PATTERN.test(displayName);
}
/**
 * Haengt die KI-Kennzeichnung an, falls sie fehlt. Wird serverseitig auf jeden
 * Anzeigenamen angewendet — auch auf den vom Nutzer eingegebenen.
 */
export function ensureAiMarker(displayName) {
    const trimmed = displayName.trim().replace(/\s+/g, ' ');
    if (trimmed.length === 0)
        return AI_MARKER;
    if (hasAiMarker(trimmed))
        return trimmed;
    return `${trimmed} ${AI_MARKER}`;
}
/** Nachricht, die der Bot beim Beitreten in den Meeting-Chat postet. */
export function buildTransparencyMessage(input) {
    return [
        /*
         * Ohne Wiederholung der Kennzeichnung: der Name traegt sie bereits, und
         * "(AI-AVA) ist ein KI-Avatar" sagt zweimal dasselbe.
         *
         * Die Aussage "kein Mensch" bleibt aber stehen. Sie ist der Kern der
         * Zusage an die Teilnehmer und darf nicht mit der Doppelung verschwinden -
         * eine Abkuerzung allein erkennt nicht jeder als KI-Kennzeichnung.
         */
        `Hinweis: "${input.displayName}" ist kein Mensch.`,
        `Gestartet von: ${input.startedBy}.`,
        'Das Audio dieses Meetings wird in Echtzeit verarbeitet, um Antworten zu erzeugen.',
        'Es wird nichts aufgezeichnet und kein Transkript gespeichert.',
    ].join(' ');
}
//# sourceMappingURL=transparency.js.map